import { Icon } from "@iconify/react/dist/iconify.js";
import React, {  useEffect, useState } from "react";
//import { SignUpContext } from "../AuthContext/SignUpContext";
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { formatDcfText } from "../utils/displayText";

const departments = [
  { id: "1", name: "Forest" },
  { id: "2", name: "Wildlife" },
];

const DfoUpdateLayerCustom = ({ dfoId }) => {
  //const useSignUp = useContext(SignUpContext);
  //const { signup } = useSignUp;
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;

  const [signUpData, setSignUpData] = useState({
    firstname: "",
    lastname: "",
    phoneno: "",
    email: "",
    address: "",
    designation: "1",
    department: "",
    emergency_contact_name: "",
    emergency_contact_number: "",
    emergency_contact_address: "",
    place_of_posting: "", 
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchDfoData = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/users/get-user-by-id/${dfoId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.status) {
          const dfoData = response.data.data;
          console.log("dddddddddddd")
          console.log(dfoData)
          setSignUpData({
            firstname: dfoData.first_name || "",
            lastname: dfoData.last_name || "",
            phoneno: dfoData.phone_no || "",
            email: dfoData.email || "",
            address: dfoData.address || "",
            designation: dfoData.designation || "1", // Fixed typo from 'designation' to 'designation'
            department: dfoData.department || "",
            emergency_contact_name: dfoData.emergency_contact_name || "",
            emergency_contact_number: dfoData.emergency_contact_number || "",
            emergency_contact_address: dfoData.emergency_contact_address || "",
            place_of_posting: dfoData.forest_division_id?.name || "",
          });
        }
      } catch (error) {
        toast.error("Failed to fetch DCF data. Please try again.");
        console.error("Error fetching DCF data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (dfoId) {
      fetchDfoData();
    }
  }, [dfoId,API_BASE_URL]);

  const handleSignUpChange = (e) => {
    const { name, value } = e.target;
    setSignUpData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
  // Explicitly pick only allowed fields
  const backendData = {
    first_name: signUpData.firstname || "",
    last_name: signUpData.lastname || "",
    phone_no: signUpData.phoneno || "",
    email: signUpData.email || "",
    address: signUpData.address || "",
    designation: signUpData.designation || "",
    department: signUpData.department || "",
    emergency_contact_name: signUpData.emergency_contact_name || "",
    emergency_contact_number: signUpData.emergency_contact_number || "",
    emergency_contact_address: signUpData.emergency_contact_address || "",
    place_of_posting: signUpData.place_of_posting || "",
  };

  const token = localStorage.getItem("token");
  const response = await axios.put(
    `${API_BASE_URL}/backend/users/${dfoId}`,
    backendData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (response.data.status) {
    toast.success("DCF updated successfully!");
  } else {
    toast.error("Failed to update DCF.");
  }
    } catch (error) {
      console.error("Update error:", error);
      const errorMessage = error.response?.data?.message || 
                         error.response?.data?.error || 
                         "An error occurred while updating the DCF.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
      <form onSubmit={handleSignUp}>
        <div className="text-center mb-6">
          <h6 className="mb-4 text-3xl font-extrabold text-gray-800 flex items-center justify-center bg-gray-100 p-4 rounded-lg shadow-md">
            <Icon icon="mdi:account-edit" className="text-4xl mx-3 my-1" />
            DCF Update Form
          </h6>
        </div>
        <ToastContainer />
        <div className="row gy-3">
        {[
          { label: "First Name", name: "firstname", icon: "mdi:account" },
          { label: "Last Name", name: "lastname", icon: "mdi:account" },
          { label: "Designation (Not changebale)", name: "designation", icon: "mdi:badge-account" },
          { label: "Contact No", name: "phoneno", icon: "mdi:phone" },
          { label: "Email ", name: "email", icon: "mdi:email", type: "email" },
          { label: "Emergency Contact Name", name: "emergency_contact_name", icon: "mdi:account-alert" },
          { label: "Emergency Contact Address", name: "emergency_contact_address", icon: "mdi:home-alert" },
        ].map(({ label, name, icon, type = "text" }) => (
          <div className="col-lg-4 col-md-6 col-sm-12" key={name}>
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon={icon} className="text-lg" />
              {label}
            </label>
            <input
              type={type}
              name={name}
              value={name === "designation" ? formatDcfText(signUpData[name]) : signUpData[name]}
              onChange={handleSignUpChange}
              className="form-control h-56-px bg-neutral-50 radius-12 shadow-sm"
              placeholder={label}
              required={name !== "emergency_contact_address"}
              disabled={isLoading}
              readOnly={name==="designation" || name==="department" } // ✅ makes these read-only
            />
          </div>
        ))}

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:office-building" className="text-lg" />
              Department (Not Changebale)
            </label>
            <select
              name="department"
              value={signUpData.department}
              onChange={handleSignUpChange}
              className="form-control h-56-px bg-neutral-50 radius-12 d-flex align-items-center shadow-sm"
              required
              disabled={isLoading}
            >
              <option value="">Select Department</option>
              {departments.map((dept) => (
                <option key={dept.id} value={dept.id}>
                  {dept.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:home" className="text-lg" />
              Address
            </label>
            <textarea
              name="address"
              className="form-control bg-neutral-50 radius-12 shadow-sm"
              rows={2}
              placeholder="e.g., House No. 123, Street No. 4, Forest Colony Lahore"
              value={signUpData.address}
              onChange={handleSignUpChange}
              required
              disabled={isLoading}
            />
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button
            className="btn btn-success text-sm btn-sm px-6 py-12 radius-12 my-24 mx-10 col-lg-3 col-md-6 col-sm-12"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="d-flex align-items-center justify-content-center">
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Updating...
              </span>
            ) : 'Update DCF'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DfoUpdateLayerCustom;
